import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";

const MultipleImageSectionItem = (props) => {

    const { imageURLS, title, textArray, layout, imagePosition } = props // layout > row y column; side > before y after

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="main-middle-section-mobile">


                    {
                        (imagePosition === "before") ? <section className="flex w100 jcenter gap-20 wrap"> {(imageURLS?.map((url, index) => <img loading="lazy" alt="Imagen" key={index} src={url} className="square-image"></img>))} </section> : <></>
                    }

                    <section className="main-middle-subsection-mobile">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((text, index) => {
                                return (<article key={index}>{parse(text)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ? <section className="flex w100 jcenter gap-20 wrap"> {(imageURLS?.map((url, index) => <img loading="lazy" alt="Imagen" key={index} src={url} className="square-image"></img>))} </section> : <></>
                    }
                </section>
            </section>
        )
    else
        return (
            <section className="flex w100 white-bkg">
                <section className={(layout === "column") ? "flex col acenter jcenter pad-30 main-middle-section-2 " : "flex  acenter jcenter pad-30 main-middle-section-2"}>

                    {
                        (imagePosition === "before") ? <section className="flex w100 jcenter gap-20"> {(imageURLS?.map((url, index) => <img loading="lazy" alt="Imagen" key={index} src={url} className="multi-section-image"></img>))} </section> : <></>
                    }

                    <section className="main-middle-subsection-2 w100">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((text, index) => {
                                return (<article key={index}>{parse(text)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ? <section className="flex w100 jcenter gap-20"> {(imageURLS?.map((url, index) => <img loading="lazy" alt="Imagen" key={index} src={url} className="multi-section-image"></img>))} </section> : <></>
                    }
                </section>
            </section>
        )



}

export default MultipleImageSectionItem